<div class="container-fluid">
  <div class="d-flex flex-column flex-sm-row">
    <app-input class="m-1" size="0" [label]="'search'" [formControl]="form_name" (valueChanged)="applyFilter()"
      [prefixIcon]="'search'"></app-input>

    <mat-accordion class="m-1">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Filtres
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-group">
          <app-select class="m-1" [label]="'planType'" [formControl]="form_planType" [list]="availablePlanTypes"
            [isMultiple]="false" [isEnum]="true" enumName="SubscriptionPlanType"
            (valueChanged)="updateDataFromFilters()"></app-select>

          <app-select class="m-1" [label]="'state'" [formControl]="form_state" [list]="availableStates"
            [isMultiple]="false" [isEnum]="true" enumName="SubscriptionState"
            (valueChanged)="updateDataFromFilters()"></app-select>

          <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns" class="m-3">Afficher toutes
            colonnes</mat-slide-toggle>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <mat-divider></mat-divider>
  <div class="table-container">
    <div class="loading" *ngIf="isLoadingResults">
      <mat-spinner color="primary"></mat-spinner>
    </div>
    <table mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear
      matSortDirection="desc">
      <ng-container matColumnDef="planType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Plan</th>
        <td mat-cell *matCellDef="let row">{{ row.planType }}</td>
      </ng-container>
      <ng-container matColumnDef="managementType">
        <th mat-header-cell *matHeaderCellDef>Gestion</th>
        <td mat-cell *matCellDef="let row">{{ row.managementType }}</td>
      </ng-container>
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>État</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.state }}</td>
      </ng-container>
      <ng-container matColumnDef="dateCreate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Créé le</th>
        <td mat-cell *matCellDef="let row">{{ row.dateCreate | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="dateStart">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Début</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.dateStart | dateFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="dateEnd">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Fin</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.dateEnd | dateFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>Utilisateur</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.user }}
          <mat-icon class="filter-icon" color="primary" (click)="showUserInfo(row.userId)"
            appTooltip="Détails de l'utilisateur">info</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="lastConnection">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Dernière connexion le</th>
        <td mat-cell *matCellDef="let row">{{ row.lastConnection | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="events">
        <th mat-header-cell *matHeaderCellDef>Activité</th>
        <td mat-cell *matCellDef="let row">
          <mat-icon *ngIf="row.subscription.events.length>0" class="filter-icon" color="primary"
            (click)="showEvents(row.subscription)" appTooltip="Voir l'activité">read_more</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="externalId">
        <th mat-header-cell *matHeaderCellDef>ID Stripe</th>
        <td mat-cell *matCellDef="let row">{{ row.externalId }}</td>
      </ng-container>
      <ng-container matColumnDef="uid">
        <th mat-header-cell *matHeaderCellDef>Uid</th>
        <td mat-cell *matCellDef="let row">{{ row.uid }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class]="row.cssClass"></tr>
    </table>
  </div>

  <mat-paginator [length]="resultsLength" [pageSize]="paging.pagingPageSize"
    [pageSizeOptions]="paging.pagingPageSizeOptions" showFirstLastButtons></mat-paginator>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li *ngIf="row.stripeUrl">
        <a [href]="row.stripeUrl" target="_blank"><mat-icon color="primary">remove_red_eye</mat-icon><span
            class="text">Voir sur Stripe</span></a>
      </li>
      <li *ngIf="row.canBeCanceled">
        <a (click)="confirmCancel(row.subscription,row.user)"><mat-icon color="primary">block</mat-icon><span
            class="text">Désactiver</span></a>
      </li>
      <li *ngIf="row.canBeExtended">
        <a (click)="goExtendTrial(row.subscription)"><mat-icon color="primary">more_time</mat-icon><span
            class="text">Modifier la durée</span></a>
      </li>
      <li *ngIf="row.canBeAdded">
        <a (click)="confirmAddTrialPlan(row.subscription.user.uid,row.user)"><mat-icon
            color="primary">add</mat-icon><span class="text">Ajouter un
            nouvel essai</span></a>
      </li>
      <li *ngIf="row.canBeOffered">
        <a (click)="confirmAddOfferedPlan(row.subscription.user.uid,row.user)"><mat-icon
            color="primary">card_giftcard</mat-icon><span class="text">Offrir l'abonnement (ou le rattacher à
            l'agence)</span></a>
      </li>
    </ul>
  </ng-template>
</mat-menu>